module.exports = __webpack_public_path__ + "static/find-more-2d0baa75f9008027765844a24337ba73.png";